// Just a random string which essentially hides all interactions from the video
// (because such ID cannot be generated). Useful when we want to hide all interactions
// due to video change due to hitting the video end
export const HIGHLIGHT_NOTHING_HIDE_EVERYTHING =
  'highlight-nothing-hide-everything';
